module.exports = __webpack_public_path__ + "img/water_meter_color.a2a1667b.svg";